import { Button } from '@/components/ui/button';
import { CheckCircle, FileText, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SubmitGuestPostPage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-4">Submit a Guest Post</h1>
          <p className="text-lg text-muted-foreground mb-12">
            Share your expertise with our community of students, educators, and professionals.
          </p>

          <div className="bg-secondary rounded-sm p-8 mb-12">
            <h2 className="text-2xl font-playfair font-bold text-foreground mb-4">Why Write for Us?</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start gap-2">
                <CheckCircle size={20} className="text-accent mt-0.5" />
                <span>Reach a targeted audience of 50,000+ education enthusiasts monthly</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle size={20} className="text-accent mt-0.5" />
                <span>Build your authority in the education space</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle size={20} className="text-accent mt-0.5" />
                <span>Get a byline with author bio and social links</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle size={20} className="text-accent mt-0.5" />
                <span>Drive traffic back to your website or platform</span>
              </li>
            </ul>
          </div>

          <div className="mb-12">
            <h2 className="text-2xl font-playfair font-bold text-foreground mb-6">Guest Post Guidelines</h2>
            
            <div className="space-y-6">
              <div className="border border-border/40 rounded-sm p-6 bg-card">
                <h3 className="text-lg font-playfair font-bold mb-3">Content Topics</h3>
                <p className="text-muted-foreground mb-3">We accept articles on:</p>
                <ul className="list-disc ml-6 text-muted-foreground space-y-1">
                  <li>University admissions and application tips</li>
                  <li>Study abroad experiences and guides</li>
                  <li>Career development and skills</li>
                  <li>Scholarship and funding opportunities</li>
                  <li>Online learning and education technology</li>
                  <li>Student life and campus culture</li>
                </ul>
              </div>

              <div className="border border-border/40 rounded-sm p-6 bg-card">
                <h3 className="text-lg font-playfair font-bold mb-3">Requirements</h3>
                <ul className="list-disc ml-6 text-muted-foreground space-y-1">
                  <li>Original content (not published elsewhere)</li>
                  <li>Minimum 1000 words, maximum 2500 words</li>
                  <li>Well-researched with credible sources</li>
                  <li>Proper formatting with headings and subheadings</li>
                  <li>High-quality images (optional but encouraged)</li>
                  <li>SEO-friendly with relevant keywords</li>
                </ul>
              </div>

              <div className="border border-border/40 rounded-sm p-6 bg-card">
                <h3 className="text-lg font-playfair font-bold mb-3">Submission Process</h3>
                <ol className="list-decimal ml-6 text-muted-foreground space-y-1">
                  <li>Send your article pitch or completed draft to our editorial team</li>
                  <li>Include a brief author bio (50-100 words) with photo</li>
                  <li>Our team will review within 5-7 business days</li>
                  <li>If approved, we'll schedule publication and notify you</li>
                </ol>
              </div>
            </div>
          </div>

          <div className="bg-primary text-primary-foreground rounded-sm p-8 text-center">
            <Mail size={48} className="mx-auto mb-4" />
            <h2 className="text-2xl font-playfair font-bold mb-4">Ready to Submit?</h2>
            <p className="mb-4 text-primary-foreground/90">
              Send your guest post proposal to:<br />
              <strong>contact@insidehighereducation.eu</strong>
            </p>
            <Link to="/contact">
              <Button size="lg" variant="secondary" className="rounded-sm" data-testid="submit-post-btn">
                Contact Editorial Team
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}